import React, { useState } from "react";

import { Button, Col, Container, Row } from "react-bootstrap";

import classNames from "classnames";
import { Link } from "react-router-dom";
import { ROUTES } from "src/routes";

import { ParticipantTypes } from "@api/graphql";
import { ParticipantWithSinglePseudonym } from "@components/account_profile/ParticipantDropdown";
import ParticipantSearch from "@components/account_profile/ParticipantSearch";

import styles from "./csv/UploadCsv.module.scss";

export const SelectParticipant = () => {
  const [participant, setParticipant] = useState<ParticipantWithSinglePseudonym | null>();
  return (
    <Container fluid className={classNames(styles["container"])}>
      <Row className="mb-5">
        <Col>
          <h2>Select Customer for the Report</h2>{" "}
        </Col>
      </Row>
      <Row className={classNames(styles["search-container"])}>
        <Col>
          <ParticipantSearch
            onParticipantSelect={(e) => {
              setParticipant(e);
            }}
            variables={{
              filter_by: [
                { field: "participantType", in: [ParticipantTypes.AMP, ParticipantTypes.ART_CENTRE] },
                { field: "excludeConferrers", ne: "" },
                { field: "filterByParticipantId", eq: "true" },
              ],
            }}
          />
        </Col>
      </Row>
      <Row>
        <Link
          to={participant !== null ? ROUTES.ResaleSubmission.ArtistDetails.path : ""}
          state={{ participant: participant }}
        >
          <Button variant="primary" disabled={participant === undefined}>
            Next
          </Button>
        </Link>
      </Row>
    </Container>
  );
};
